import { createContext } from 'react';

export const DashboardContext = createContext("");

export const ServiceSelectContext = createContext("");

export const RejectionResponseContext = createContext("");

export const OthersComponentContext = createContext("");